import { ProfileActionUnion, ProfileActionTypes } from './actions';
import { ProfileOverviewState } from './state';

export const defaultProfileState: ProfileOverviewState = {
  activeAccount: undefined,
  account: undefined,
  loading: false,
  error: undefined
};

export function profileReducer(
  state: ProfileOverviewState = defaultProfileState,
  action: ProfileActionUnion
): ProfileOverviewState {
  switch (action.type) {
    case ProfileActionTypes.SetActiveAccount:
      return {
        ...state,
        ...(action.payload
          ? {
              activeAccount: action.payload,
              account: undefined,
              loading: true,
              error: undefined
            }
          : defaultProfileState)
      };

    case ProfileActionTypes.LoadRequested:
      return {
        ...state,
        account: undefined,
        loading: true,
        error: undefined
      };

    case ProfileActionTypes.LoadSuccess:
      return {
        ...state,
        account: action.payload,
        loading: false,
        error: undefined
      };

    case ProfileActionTypes.LoadFailed:
      return {
        ...state,
        account: undefined,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
}
